document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.footer__block-link_list');
    accordionItems.forEach((item) => {
      const content = item.querySelector('.footer-block__details-content.list-unstyled');
      item.querySelector('.footer-block__heading--link-list').addEventListener('click', () => {
        const isOpen = item.classList.contains('accordion__item--open');
        if (!isOpen) {
          item.classList.add('accordion__item--open');
          content.style.maxHeight = `${content.scrollHeight}px`;
        } else {
          item.classList.remove('accordion__item--open');
          content.style.maxHeight = null;
        }
      });
    });
  });